var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTllBird(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "17.1 19.4 51.53 49.55",
    width: 51.53,
    height: 49.55,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#534A43",
    d: "M65.54,34.73l-.3.33-.19.02c-15.56,1.81-24.59,4.38-29.18,7.3.58-2.87,2.01-6.3,5.08-8.7,9.41-.99,20.13.37,24.11.96l.48.08Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#534A43",
    d: "M58.23,20.37c-10.79,6.16-28.08,16.77-28.08,25.03,0,11.07,27.98,14.29,37.98,14.58l-.58.36c-10.51.26-21.9-.67-30.84-4.18-9.18-3.61-14.87-8.37-15.94-18.19-.08-.88-.31-1.77-.65-2.53-.64-1.14-1.64-1.72-2.39-1.91-.04-.01-.09-.02-.13-.03l.19-.31c.92-.02,1.49.02,2.01.08.35-.37,1.87-1.82,3.85-1.41,1.45.3,2.32.99,2.85,1.73,8.87-8.19,26.3-12.47,31.46-13.6l.46-.09-.18.46"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#534A43",
    d: "M41.04,58.71c-1.88-.15-3.69-.47-5.03-.75,9.14,6.57,23.32,10.31,23.99,10.49l.62-.15c-13.32-5.3-19.22-9.34-19.57-9.58Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTllBird);
export default __webpack_public_path__ + "static/media/tll-bird.7a3c01e52b7f5f356d517e34222ee962.svg";
export { ForwardRef as ReactComponent };